import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import ReactDom from "react-dom";
import Input from "./Input";
import { setAnnouncement } from "../../actions/adminActions";
const CreateAnnouncement = ({ open }) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    highlight: "",
    text: "",
  });
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  if (!open) return null;
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setAnnouncement(formData);
  };
  return ReactDom.createPortal(
    <div className="modal-container">
      <div className="modal-session">
        <form onSubmit={handleSubmit} className="widthContainer">
          <Input
            type="text"
            handleChange={handleChange}
            value={formData.highlight}
            name="highlight"
            id="highlight"
            autoComplete="off"
            direction="column"
            errorHandler="true"
          />
          <Input
            type="text"
            handleChange={handleChange}
            value={formData.text}
            name="text"
            id="text"
            autoComplete="off"
            direction="column"
            errorHandler="true"
          />
          <button type="submit">Set Announcement</button>
        </form>
      </div>
    </div>,
    document.getElementById("portal")
  );
};

export default CreateAnnouncement;
